/**
 * assets/bundle-builder.js
 * Custom subscription bundle builder interactivity.
 *
 * Handles: steppers, tier progress, sidebar items, CTA price, Recharge ATC submit,
 * URL preselect (?add=product-handle), learn more modal.
 */
(function () {
  'use strict';

  function formatMoney(pence) {
    var pounds = (pence / 100).toFixed(2);
    return '\u00A3' + pounds.replace(/\.00$/, '');
  }

  function initBundleBuilder(el) {
    var sectionId = el.dataset.sectionId;
    var dataEl = document.getElementById('bb-data-' + sectionId);
    if (!dataEl) return;

    var bbData;
    try {
      bbData = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('[BundleBuilder] Invalid JSON data', e);
      return;
    }

    var tiers = (bbData.tiers || []).filter(function (t) { return t.threshold > 0; });
    var productMap = {};
    (bbData.products || []).forEach(function (p) { productMap[p.id] = p; });

    var maxThreshold = tiers.length ? tiers[tiers.length - 1].threshold : 12000;

    // ── DOM refs ──────────────────────────────────────────────────────────────
    var rows = el.querySelectorAll('.bb__flavour-row');
    var tierTrackEl = el.querySelector('.bb__tier-track');
    var tierFillEl = el.querySelector('.bb__tier-fill');
    var tierNodes = el.querySelectorAll('.bb__tier-node');
    var tierMsgEl = el.querySelector('.bb__tier-message');
    var itemsEmptyEl = el.querySelector('.bb__items-empty');
    var itemsListEl = el.querySelector('.bb__items-list');
    var itemsTotalEl = el.querySelector('.bb__items-total');
    var itemsTotalPriceEl = el.querySelector('.bb__items-total-price');
    var ctaBtns = el.querySelectorAll('.bb__cta');
    var ctaSavingEl = el.querySelector('.bb__cta-saving');
    var mobileCountEl = el.querySelector('.bb__mobile-count');
    var mobileDiscountEl = el.querySelector('.bb__mobile-discount');
    var giftEls = el.querySelectorAll('.bb__gift');
    var lmOverlay = el.querySelector('.pdp-v3__learn-more-overlay');
    var lmBody = lmOverlay ? lmOverlay.querySelector('.pdp-v3__learn-more-body') : null;
    var lmClose = lmOverlay ? lmOverlay.querySelector('.pdp-v3__learn-more-close') : null;

    // ── State ─────────────────────────────────────────────────────────────────
    var qtys = {}; // productId (string) -> qty (int)
    rows.forEach(function (row) { qtys[row.dataset.productId] = 0; });

    // ── Helpers ───────────────────────────────────────────────────────────────
    function getCurrentTier(otpTotal) {
      var current = null;
      for (var i = 0; i < tiers.length; i++) {
        if (otpTotal >= tiers[i].threshold) current = tiers[i];
      }
      return current;
    }

    function getNextTier(otpTotal) {
      for (var i = 0; i < tiers.length; i++) {
        if (otpTotal < tiers[i].threshold) return tiers[i];
      }
      return null;
    }

    function calcTotals() {
      var otpTotal = 0;
      var totalQty = 0;
      rows.forEach(function (row) {
        var qty = qtys[row.dataset.productId] || 0;
        if (qty === 0) return;
        var step = parseInt(row.dataset.step, 10) || 1;
        var packs = qty / step;
        var price = parseInt(row.dataset.price, 10) || 0;
        otpTotal += Math.round(packs * price);
        totalQty += qty;
      });
      return { otpTotal: otpTotal, totalQty: totalQty };
    }

    // ── Stepper ───────────────────────────────────────────────────────────────
    rows.forEach(function (row) {
      var step = parseInt(row.dataset.step, 10) || 1;
      var qtyEl = row.querySelector('.bb__row-qty');
      var minusBtn = row.querySelector('.bb__row-minus');
      var plusBtn = row.querySelector('.bb__row-plus');
      if (!qtyEl || !plusBtn) return;

      function setQty(newQty) {
        qtyEl.textContent = newQty;
        qtys[row.dataset.productId] = newQty;
        var active = newQty > 0;
        if (minusBtn) {
          minusBtn.style.display = active ? '' : 'none';
          minusBtn.style.backgroundColor = active ? 'rgba(229,216,200,0.8)' : 'white';
        }
        plusBtn.style.backgroundColor = active ? 'rgba(229,216,200,0.8)' : 'white';
        update();
      }

      plusBtn.addEventListener('click', function () {
        setQty((parseInt(qtyEl.textContent, 10) || 0) + step);
      });
      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          var current = parseInt(qtyEl.textContent, 10) || 0;
          if (current <= 0) return;
          setQty(Math.max(0, current - step));
        });
      }
    });

    // ── Update all UI ─────────────────────────────────────────────────────────
    function update() {
      var totals = calcTotals();
      var currentTier = getCurrentTier(totals.otpTotal);
      var nextTier = getNextTier(totals.otpTotal);

      updateTierBar(totals.otpTotal, currentTier, nextTier);
      updateItemsList(totals.otpTotal, currentTier);
      updateCTA(totals.otpTotal, totals.totalQty, currentTier);
      updateMobileBar(totals.totalQty, currentTier);
      updateGifts(totals.otpTotal);
    }

    // ── Tier bar ──────────────────────────────────────────────────────────────
    function updateTierBar(otpTotal, currentTier, nextTier) {
      if (tierFillEl) {
        var pct = Math.min(otpTotal / maxThreshold, 1) * 100;
        tierFillEl.style.width = pct + '%';
      }

      tierNodes.forEach(function (node) {
        var idx = parseInt(node.dataset.tierIndex, 10);
        var isActive = tiers[idx] && otpTotal >= tiers[idx].threshold;
        node.classList.toggle('bb__tier-node--active', isActive);
      });

      if (tierMsgEl) {
        if (!nextTier) {
          tierMsgEl.textContent = 'Maximum discount unlocked — you\'re getting ' + currentTier.discount + '% off!';
        } else if (!currentTier) {
          var needed = nextTier.threshold - otpTotal;
          tierMsgEl.textContent = 'Spend ' + formatMoney(needed) + ' more to unlock ' + nextTier.discount + '% off';
        } else {
          var needed = nextTier.threshold - otpTotal;
          tierMsgEl.textContent = currentTier.discount + '% off unlocked — spend ' + formatMoney(needed) + ' more for ' + nextTier.discount + '% off';
        }
      }
    }

    // ── Items list ────────────────────────────────────────────────────────────
    function updateItemsList(otpTotal, currentTier) {
      if (!itemsListEl || !itemsEmptyEl) return;

      var hasItems = false;
      itemsListEl.innerHTML = '';

      rows.forEach(function (row) {
        var qty = qtys[row.dataset.productId] || 0;
        if (qty === 0) return;
        hasItems = true;

        var p = productMap[row.dataset.productId];
        var name = p ? (p.flavourName || p.rangeName || '') : '';
        var step = parseInt(row.dataset.step, 10) || 1;
        var packs = qty / step;
        var price = parseInt(row.dataset.price, 10) || 0;
        var lineTotal = Math.round(packs * price);

        var li = document.createElement('li');
        li.className = 'bb__item';
        li.innerHTML =
          (p && p.image ? '<img src="' + p.image + '" alt="' + name + '" class="bb__item-img" loading="lazy">' : '') +
          '<span class="bb__item-name">' + name + '</span>' +
          '<span class="bb__item-qty">\u00D7' + qty + '</span>';
        itemsListEl.appendChild(li);
      });

      itemsEmptyEl.style.display = hasItems ? 'none' : '';
      itemsListEl.style.display = hasItems ? '' : 'none';

      if (itemsTotalEl && itemsTotalPriceEl) {
        if (hasItems && currentTier) {
          var discounted = Math.round(otpTotal * (1 - currentTier.discount / 100));
          itemsTotalPriceEl.innerHTML =
            '<span style="text-decoration:line-through;opacity:0.4;margin-right:4px;">' + formatMoney(otpTotal) + '</span>' +
            formatMoney(discounted);
          itemsTotalEl.style.display = '';
        } else if (hasItems) {
          itemsTotalPriceEl.textContent = formatMoney(otpTotal);
          itemsTotalEl.style.display = '';
        } else {
          itemsTotalEl.style.display = 'none';
        }
      }
    }

    // ── CTA ───────────────────────────────────────────────────────────────────
    function updateCTA(otpTotal, totalQty, currentTier) {
      var isEmpty = totalQty === 0;

      ctaBtns.forEach(function (btn) {
        btn.disabled = isEmpty;
        var priceEl = btn.querySelector('.bb__cta-price');
        var pipeEl = btn.querySelector('.bb__cta-pipe');

        if (priceEl) {
          if (isEmpty) {
            priceEl.style.display = 'none';
          } else {
            var discount = currentTier ? currentTier.discount : 0;
            var displayTotal = Math.round(otpTotal * (1 - discount / 100));
            priceEl.textContent = formatMoney(displayTotal);
            priceEl.style.display = '';
          }
        }
        if (pipeEl) pipeEl.style.display = isEmpty ? 'none' : '';
      });

      if (ctaSavingEl) {
        if (!isEmpty && currentTier) {
          var saving = otpTotal - Math.round(otpTotal * (1 - currentTier.discount / 100));
          ctaSavingEl.textContent = 'Saving ' + currentTier.discount + '% (' + formatMoney(saving) + ') every delivery';
          ctaSavingEl.style.display = '';
        } else {
          ctaSavingEl.style.display = 'none';
        }
      }
    }

    // ── Mobile bar ────────────────────────────────────────────────────────────
    function updateMobileBar(totalQty, currentTier) {
      if (mobileCountEl) {
        mobileCountEl.textContent = totalQty + (totalQty === 1 ? ' item' : ' items');
      }
      if (mobileDiscountEl) {
        if (currentTier) {
          mobileDiscountEl.textContent = currentTier.discount + '% off unlocked';
          mobileDiscountEl.style.display = '';
        } else {
          mobileDiscountEl.style.display = 'none';
        }
      }
    }

    // ── Gifts ─────────────────────────────────────────────────────────────────
    function updateGifts(otpTotal) {
      giftEls.forEach(function (gift) {
        var threshold = parseInt(gift.dataset.threshold, 10) || 0;
        var unlocked = otpTotal >= threshold;
        gift.classList.toggle('bb__gift--unlocked', unlocked);
      });
    }

    // ── Submit (Recharge bundle) ──────────────────────────────────────────────
    function submitBundle() {
      var totals = calcTotals();
      if (totals.totalQty === 0) return;

      var bundleId = 'bundle-' + Date.now();
      var items = [];

      rows.forEach(function (row) {
        var qty = qtys[row.dataset.productId] || 0;
        if (qty === 0) return;
        var variantId = parseInt(row.dataset.variantId, 10);
        var sellingPlanId = parseInt(row.dataset.sellingPlan, 10);
        var item = {
          id: variantId,
          quantity: qty,
          properties: { '_rc_bundle': bundleId }
        };
        if (sellingPlanId) item.selling_plan = sellingPlanId;
        items.push(item);
      });

      // Disable CTA while submitting
      ctaBtns.forEach(function (btn) {
        btn.disabled = true;
        var labelEl = btn.querySelector('.bb__cta-label');
        if (labelEl) {
          btn.dataset.originalLabel = labelEl.textContent;
          labelEl.textContent = 'Adding to cart\u2026';
        }
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || 'Cart error'); });
        window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('[BundleBuilder] Cart add failed:', err);
        ctaBtns.forEach(function (btn) {
          btn.disabled = false;
          var labelEl = btn.querySelector('.bb__cta-label');
          if (labelEl && btn.dataset.originalLabel) labelEl.textContent = btn.dataset.originalLabel;
        });
        // Re-run update to restore disabled state properly
        update();
        alert('Sorry, something went wrong adding to cart. Please try again.');
      });
    }

    ctaBtns.forEach(function (btn) {
      btn.addEventListener('click', submitBundle);
    });

    // ── Learn more modal ──────────────────────────────────────────────────────
    if (lmOverlay && lmBody) {
      // Open
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('.pdp-v3__learn-more-btn');
        if (!btn || !el.contains(btn)) return;
        var productId = btn.dataset.productId;
        var contentEl = el.querySelector('.bb__lm-contents .pdp-v3__learn-more-content[data-product-id="' + productId + '"]');
        if (!contentEl) return;
        lmBody.innerHTML = contentEl.innerHTML;
        lmOverlay.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
      });

      // Close button
      if (lmClose) {
        lmClose.addEventListener('click', closeLM);
      }

      // Click outside box
      lmOverlay.addEventListener('click', function (e) {
        if (e.target === lmOverlay) closeLM();
      });

      // Escape key
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !lmOverlay.classList.contains('hidden')) closeLM();
      });

      function closeLM() {
        lmOverlay.classList.add('hidden');
        document.body.style.overflow = '';
      }

      // Accordion delegation inside modal body
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('.pdp-v3__accordion-trigger');
        if (!trigger || !lmBody.contains(trigger)) return;
        var accordion = trigger.closest('.pdp-v3__accordion');
        if (!accordion) return;
        var body = accordion.querySelector('.pdp-v3__accordion-body');
        if (!body) return;
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!expanded));
        body.classList.toggle('hidden', expanded);
      });
    }

    // ── URL preselect (?add=product-handle) ──────────────────────────────────
    var params = new URLSearchParams(window.location.search);
    var addHandle = params.get('add');
    if (addHandle) {
      rows.forEach(function (row) {
        if (row.dataset.handle !== addHandle) return;
        var step = parseInt(row.dataset.step, 10) || 1;
        var qtyEl = row.querySelector('.bb__row-qty');
        var minusBtn = row.querySelector('.bb__row-minus');
        var plusBtn = row.querySelector('.bb__row-plus');
        if (!qtyEl) return;
        qtyEl.textContent = step;
        qtys[row.dataset.productId] = step;
        if (minusBtn) {
          minusBtn.style.display = '';
          minusBtn.style.backgroundColor = 'rgba(229,216,200,0.8)';
        }
        if (plusBtn) plusBtn.style.backgroundColor = 'rgba(229,216,200,0.8)';
        // Scroll to row
        row.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    // Initial render
    update();
  }

  // Init all bundle builder instances
  document.querySelectorAll('.bb[data-section-id]').forEach(initBundleBuilder);

})();
